/*
 * Copyright (c) 2023. American Express Company
 */

export enum CardStyleType {
    STANDARD = 'standard',
    SPECIAL = 'special'
}
